import I18nHtml from '@/components/I18nHtml'
import analytics, { getDonationFormType } from '@betterplace/product-analytics'
import classNames from 'classnames'
import styles from './ZeroCodonationMessage.module.css'
import { Expandable } from '@betterplace/design-system/client'
import { useDonationFormConfig } from '@/donationPages/_dependencies/helpers'
import { useEffect } from 'react'
import { useZeroCodonationMessageContext } from './ZeroCodonationMessageContext'

function ZeroCodonationMessage({
  value,
  onShow,
  className,
}: {
  value: number
  onShow?: () => void
  className?: string
}) {
  const { receiverId, receiverType, channel, showCodonation } = useDonationFormConfig()
  const { shown, show } = useZeroCodonationMessageContext()

  useEffect(() => {
    if (value !== 0) return
    analytics.coDonationSetToZero({
      id: receiverId,
      receiver_type: receiverType,
      donation_form_type: getDonationFormType({
        receiverId,
        receiverType,
        channel,
        showCodonation,
      }),
    })
    if (shown) return
    show()
  }, [channel, receiverId, receiverType, show, showCodonation, shown, value, onShow])
  useEffect(() => {
    if (!shown) return
    onShow?.()
  }, [shown, onShow])
  return (
    <Expandable open={shown}>
      <I18nHtml
        className={classNames(styles.zeroCodonationMessage, className)}
        i18nKey="nextjs.donate.codonation_box.zero_codonation_message_html"
        aria-live="polite"
      />
    </Expandable>
  )
}

export default ZeroCodonationMessage
